import styled from 'styled-components'
import { colors } from '../../../../constants'
import { Input, Padding } from '../../../../components'
import { Label } from '../../../../components/Form'

export const NameSection = styled(Padding)`
    color: ${colors.white};
`

export const EditButton = styled.button`
    background: transparent;
    border: none;
    cursor: pointer;
    margin-left: 10px;
`

export const MessageSection = styled.span`
    margin-right: 10px;
`

export const UnsavedChanges = styled(MessageSection)`
    color: ${colors.orange};
`

export const ImagePreview = styled.img`
    height: auto;
    width: 100%;
    overflow: hidden;
`

export const InputFileButton = styled(Input)`
    border-radius: 5px;
    cursor: pointer;
    transition: 0.3s all;
    position: relative;
    vertical-align: middle;
    font-size: 15px;
    padding: 10px;
    width: 100%;
    background: ${colors.blue};
    border: 1px solid ${colors.blue};
    color: ${colors.white};
    text-shadow: 0 0 4px #FFFFFF2c;
    margin: 0;
    font-weight: 400;
    height: 40px;
    line-height: normal;

    &:active,:focus,:hover {
        background: #1e4573;
        border: 1px solid #1e4573;
    }
`

export const FlexPadding = styled(Padding)`
    display: flex;
    justify-content: space-between;
`

export const FullWidthLabel = styled(Label)`
    width: 100%;
`

export const FullWidthInput = styled(Input)`
    width: 100%;
`
